import { render, staticRenderFns } from "./Update.vue?vue&type=template&id=168df48c&scoped=true"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
import style0 from "./Update.vue?vue&type=style&index=0&id=168df48c&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168df48c",
  null
  
)

export default component.exports